module.exports = __webpack_public_path__ + "img/W-25.960c503f.jpg";